"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerItem = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const react_1 = tslib_1.__importDefault(require("react"));
exports.DrawerItem = (props) => {
    const { active, disabled, icon, onPress, right, title } = props;
    return (react_1.default.createElement(components_1.List.Item, { disabled: disabled, selected: active, onPress: onPress, left: icon ? react_1.default.createElement(components_1.List.Icon, Object.assign({ size: 24 }, icon)) : null, title: title, right: right }));
};
